import {set, get} from "lodash"
import {AxiosRequestConfig} from "axios"

export default function removeAuthHeader(config: AxiosRequestConfig) {
  if (get(config, "headers.Authorization")) {
    set(config, "headers.Authorization", "<redacted>")
  }
}
